import React from "react";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import ServiceZone from "@/components/ServiceZone";
import Pricing from "@/components/Pricing";
import WhyChooseMe from "@/components/WhyChooseMe";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsappFloat from "@/components/WhatsappFloat";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <Services />
        <ServiceZone />
        <Pricing />
        <WhyChooseMe />
        <Gallery />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <WhatsappFloat />
    </div>
  );
}

export default App;
